class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.dialog = this.querySelector('dialog');
    this.dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event && event.code && event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();

    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (this.dialog && event.target === this.dialog) {
      const bounds = this.dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
      return;
    }
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    // Prevent layout shift when scrollbar disappears by compensating with padding-right
    try {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    } catch (e) { }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if (this.dialog) {
      // Native top-layer placement avoids clipping by the transformed sticky header.
      this.dialog.showModal();
      this.summaryToggle.setAttribute('aria-expanded', 'true');
      this.dialog.querySelector('input[type="search"]')?.focus();
    } else {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    if (this.dialog) {
      if (!this.isOpen()) return;
      this.dialog.querySelector('.search-drawer predictive-search')?.close?.();
      this.dialog.close();
      this.summaryToggle.setAttribute('aria-expanded', 'false');
      if (focusToggle) this.summaryToggle.focus();
    } else {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.style.paddingRight = '';
  }

  disconnectedCallback() {
    if (this.dialog && this.isOpen()) this.close(false);
  }
}

customElements.define('details-modal', DetailsModal);
